import type React from 'react';
import { useDrag } from 'react-dnd';
import { useRef } from 'react';
import { Paragraph } from '../..';
import IcoDrag from '../../icon/icons/IcoDrag';
import IcoVideo from '../../icon/icons/IcoVideo';
import './blockSourceButton.less';

interface VideoBlockButtonProps {
  title: string;
  onClickAdd?: () => void;
}

const VideoBlockButton: React.FunctionComponent<VideoBlockButtonProps> = ({ title, onClickAdd }) => {
  const wasDraggingRef = useRef(false);
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'VIDEO',
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    item: () => {
      wasDraggingRef.current = true;
      return { title };
    },
    end: () => {
      requestAnimationFrame(() => {
        wasDraggingRef.current = false;
      });
    },
  }));

  const handleClick = () => {
    if (wasDraggingRef.current) return;
    onClickAdd?.();
  };

  return (
    <button ref={drag} draggable className="block-source" style={{ opacity: isDragging ? 0.5 : 1 }} onClick={handleClick}>
      <div className="block-source-icon">
        <IcoVideo />
      </div>
      <div className="block-source-drag-icon">
        <IcoDrag />
      </div>
      <Paragraph size="sm">{title}</Paragraph>
    </button>
  );
};

export default VideoBlockButton;
VideoBlockButton.displayName = 'VideoBlockButton';
